<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ "ads-locations.title" | translate }}
    </h4>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClickDismissModal()"
  ></button>
</div>

<div class="modal-body">

  <!-- Select All -->
  <div class="form-check checkbox checkbox-primary mb-3">
    <input
      id="select-all"
      type="checkbox"
      class="form-check-input"
      [checked]="selectedLocations.length === locations.length"
      (change)="onToggleAll($event)"
    />
    <label class="form-check-label" for="select-all">
      {{ "ads-locations.allLocations" | translate }}
    </label>
  </div>

  <!-- Individual locations -->
  <div *ngFor="let loc of locations; let i = index" class="form-check checkbox checkbox-primary mb-2">
    <input
      [id]="'loc-' + i"
      type="checkbox"
      class="form-check-input"
      [checked]="selectedLocations.includes(loc)"
      (change)="onToggleLocation($event, loc)"
    />
    <label class="form-check-label" [for]="'loc-' + i">
      {{ loc }}
    </label>
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-primary" (click)="submitLocation()">
    {{ "buttons.confirm" | translate }}
  </button>
</div>
